export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10853.f59e5c5d.jpg";